module.exports = __webpack_public_path__ + "static/media/Take the tour personal tour version.7663a6a2.mp4";